var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tooltip',_vm._b({attrs:{"content":_vm.content,"placement":"top","transfer":true}},'Tooltip',_vm.$attrs,false),[_c('div',{staticClass:"twoLinesWrap"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }